import { handleActions } from 'redux-actions';
import ClientsType from '../types/ClientsType';

const initialState = {
  clientDetails: {
    personalInfo: {},
    limitInfo: {},
    statusInfo: {},
  },
  clientPaymentMethods: [],
  clientHistory: {
    data: [],
    page: 0,
    maxRows: 0,
    rows: 0,
  },
};

export const ClientDetails = handleActions(
  {
    [ClientsType.actions.fetchClientDetailsSuccess]: (currentState, { payload }) => {
      return {
        ...currentState,
        ...payload,
      };
    },
    [ClientsType.actions.fetchClientPaymentMethodsSuccess]: (currentState, { payload }) => {
      return {
        ...currentState,
        ...payload,
      };
    },
    [ClientsType.actions.fetchClientHistorySuccess]: (currentState, { payload }) => {
      // Concat Data if new page
      const data = payload.clientHistory.page ? currentState.clientHistory.data.concat(payload.clientHistory.data) : payload.clientHistory.data;
      const clientHistory = { ...payload.clientHistory, data };

      return {
        ...currentState,
        clientHistory,
        isLoading: false,
      };
    },
    [ClientsType.actions.fetchClientHistoryLoading]: (currentState) => {
      return {
        ...currentState,
        isLoading: true,
      };
    },
  },
  initialState
);

export const getClientDetails = (state) => {
  const { ClientDetails } = state;
  return ClientDetails.clientDetails;
};

export const getClientPaymentMethods = (state) => {
  const { ClientDetails } = state;
  return ClientDetails.clientPaymentMethods;
};

export const getClientHistory = (state) => {
  const { ClientDetails } = state;
  return ClientDetails.clientHistory;
};

export const hasMore = (state) => {
  const { ClientDetails } = state;
  return ClientDetails.rows === ClientDetails.maxRows;
};
export const getIsLoading = (state) => {
  const { ClientDetails } = state;
  return ClientDetails.isLoading;
};
